













import {Component, Prop, Vue} from 'vue-property-decorator';
import {IOfferLite, SessionStore} from '../store';
import {WebService} from '../services';

@Component
export default class OfferTile extends Vue {
	@Prop({required: true})
	offer!: IOfferLite;

	@Prop({type: Boolean, default: false})
	showBorder!: boolean;

	get offerImage(): string {
		if(this.offer.image) {
			return `${WebService.defaultHost}/${this.offer.image}`;
		}
		return SessionStore.brandConfig?.rewardImage || '';
	}
}
